export const FORGET_PASSWORD_MOBILE = '@forget/FORGET_PASSWORD_MOBILE';
export const SAVE_FORGET_PASSWORD_RES = '@forget/SAVE_FORGET_PASSWORD_RES';
